<template>
  <pages-editions-slug-participants-component
    v-if="data"
    :data="data?.data"
  />
  <shared-error-component v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const route = useRoute()

// 1
const props = defineProps({
  biennialEntryId: {
    type: Number,
    required: false
  }
})

// 2
const page = ref(1)

const { data, error, execute, status } = await useAsyncData(route.fullPath, () => {
  return $fetch('/api/strapi-rest', { query: { path: queryBienniaParticipantEntriesByBiennialId(getPageQuery({page: page.value, id: props.biennialEntryId})) } })
}, { watch: [page], immediate: true })

const canLoadMore = computed(() => {
  return data.value?.meta?.pagination?.page < data.value?.meta?.pagination?.pageCount
})

watch(data, (newValue, oldValue) => {
  if (oldValue && newValue && newValue.meta?.pagination?.page === (oldValue.meta?.pagination?.page + 1) ) {
    data.value.data = oldValue.data.concat(newValue.data)
    if (canLoadMore.value) {
      page.value++
    }
  } else if ( newValue ) {
    data.value = newValue
  }
})

setTimeout(() => {
  if (canLoadMore.value) {
    page.value++
  }
}, 10)
</script>
